<template>
  <div class="report-field-row">
    <span v-if="label" class="label">{{ label }}</span>
    <div class="badges">
      <AddBadge @click="$emit('add')">
        {{ addBadgeName }}
      </AddBadge>
      <slot name="badges"></slot>
      <SecondaryBadge
        v-if="extraCount > 0"
        class="extra-count"
        @click="$emit('add')"
      >
        +{{ extraCount }}
      </SecondaryBadge>
    </div>
  </div>
</template>
<script>
import { SecondaryBadge } from '@mikmak/components';
import AddBadge from './Badges/AddBadge.vue';

export default {
  props: {
    label: String,
    extraCount: {
      type: Number,
      default: 0,
    },
  },
  components: {
    AddBadge,
    SecondaryBadge,
  },
  computed: {
    addBadgeName() {
      if (this.label) return 'Add';

      return 'Filters';
    },
  },
};
</script>
<style scoped>
.report-field-row {
  display: flex;
  align-items: center;
  justify-content: center;
}

.badges {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  min-width: 200px;
}

.label {
  font-family: Lato;
  font-size: 12px;
  font-weight: 500;
  line-height: 16.8px;
  color: #223448;
  padding-right: 8px;
}
</style>
<style>
.actions-container .extra-count button.secondary {
  background: #00A6A4;
}
</style>
